export function isAndroid_Ios() {
  let equipmentType = '';
  const u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    equipmentType = 'android';
  } else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    equipmentType = 'ios';
  }
  return equipmentType;
}
